import { render, staticRenderFns } from "./ItemN_Packaging_List.vue?vue&type=template&id=ded821dc"
import script from "./ItemN_Packaging_List.vue?vue&type=script&lang=js"
export * from "./ItemN_Packaging_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports